export type SignalTableRow = Record<string, string | number | boolean | null>;

export const SEARCHABLE_COLUMNS = new Set([
  "signal_id",
  "category",
  "signal",
  "owners",
  "assignee",
  "linked_risks",
]);

export const FIXED_COLUMNS = new Set(["signal_id"]);

export const HIDDEN_COLUMNS = new Set<string>([
  "category",
  "current_score",
  "current_status",
  "low_threshold",
  "high_threshold",
  "owners",
  "created_by",
  "comments_governance_log",
  "longitudinal_signal_data",
  "longitudinal_signal_status",
  "band",
]);

export const SIGNAL_COLUMN_ORDER = [
  "signal_id",
  "signal",
  "current_score",
  "breach_status",
  "linked_risks",
  "linked_breaches",
  "owners",
  "assignee",
] as const;

export const TITLE_MAPPING = {
  signal_id: "Signal ID",
  category: "Category",
  signal: "Signal",
  current_score: "Current Score",
  current_status: "Current Status",
  breach_status: "Status",
  low_threshold: "Low Threshold",
  high_threshold: "High Threshold",
  linked_risks: "Linked Risks",
  linked_breaches: "Linked Breaches",
  owners: "Owners",
  assignee: "Assignee",
  created_by: "Created By",
  comments_governance_log: "Comments / Governance Log",
  longitudinal_signal_data: "Longitudinal Signal Data",
  longitudinal_signal_status: "Longitudinal Signal Status",
} satisfies Record<string, string>;

export const COLUMN_WIDTHS = {
  DEFAULT: 160,
  signal_id: 120,
  category: 140,
  signal: 360,
  current_score: 130,
  current_status: 120,
  breach_status: 140,
  low_threshold: 220,
  high_threshold: 220,
  linked_risks: 180,
  linked_breaches: 180,
  owners: 240,
  assignee: 220,
  created_by: 180,
  comments_governance_log: 320,
  longitudinal_signal_data: 320,
  longitudinal_signal_status: 320,
} satisfies Record<string, number>;
